import React from 'react';
import LoginViaQuestCode from './LoginViaQuestCode';
import './CommonComponents/Animations/animations.css'

export default () => {
  return (
   <LoginViaQuestCode />
  )
}